import React, { Component } from "react";
import { Link, animateScroll as scroll } from "react-scroll";

class Nav extends Component {
  toggle = "";

  constructor(props) {
    super(props);
    this.state = {
      toggle: "",
      menuHeight: 81 //standard height of navbar in px
    };
  }

  toggleMenu = () => {
    if (window.innerWidth < 500) {
      this.setState({
        menuHeight: 290
      });
      if (this.state.toggle) {
        this.setState({
          toggle: ""
        });
      } else {
        this.setState({
          toggle: "toggle"
        });
      }
    } else {
      scroll.scrollToTop();
      this.setState({
        menuHeight: 81
      });
    }
  };

  render() {
    return (
      <nav className="Nav">
        <div className="nav-link-container">
          <Link
            activeClass="active"
            className="nav-link"
            onClick={
              //     () => {
              //   scroll.scrollToTop();
              this.toggleMenu
            }
            spy={true}
            smooth={true}
            offset={0}
            duration={1000}
          >
            <svg
              className="icon"
              width="50px"
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m303.132812 79.265625c0 8.285156-6.714843 15-15 15-8.285156 0-15-6.714844-15-15 0-8.28125 6.714844-15 15-15 8.285157 0 15 6.71875 15 15zm0 0" />
              <path d="m497 337.398438h-174.96875c5.730469-4.835938 45.367188-37.585938 45.367188-97.511719v-97.417969h81.402343c8.285157 0 15-6.71875 15-15v-16.085938c0-61.515624-49.765625-111.382812-111.386719-111.382812h-64.296874c-35.976563 0-69.207032 11.972656-95.925782 32.132812h-32.605468c-9.441407 0-17.117188-7.679687-17.117188-17.132812 0-8.285156-6.71875-14.9921875-15-14.9921875-8.285156 0-15 6.7226565-15 15.0078125 0 25.980469 21.136719 47.117187 47.117188 47.117187h2.25c-20.867188 26.976563-33.304688 60.785157-33.304688 97.453126v8.753906c-55.390625 45.589844-64.265625 105.097656-64.265625 135.84375v33.214844h-49.265625c-8.285156 0-15 6.71875-15 15 0 8.285156 6.714844 15 15 15h113.535156v129.601562c0 8.285156 6.714844 15 15 15 52.566406 0 95.332032-42.765625 95.332032-95.332031v-49.269531h34.265624v129.601562c0 8.285156 6.71875 15 15 15 8.285157 0 15-6.714844 15-15v-129.601562h193.867188c8.285156 0 15-6.714844 15-15 0-8.28125-6.714844-15-15-15zm-63.199219-226.015626v1.085938h-66.402343v-81.101562c52.910156 9.792968 66.402343 58.09375 66.402343 80.015624zm-145.683593-81.382812h49.28125v209.886719c0 53.824219-43.535157 97.464843-97.457032 97.464843-.015625 0-.035156 0-.050781 0-6.839844 0-13.632813-.003906-20.261719-.007812 1.050782-.984375 35.304688-29.8125 35.304688-81.34375v-112.46875c0-8.28125-6.734375-15-15.019532-15-28.617187 0-56.1875 6.8125-80.875 19.644531 5.800782-66.128906 61.46875-118.175781 129.078126-118.175781zm-193.851563 274.183594c0-75.949219 57.761719-137.492188 130.667969-144.894532v96.710938c0 38.003906-29.21875 81.398438-83.003906 81.398438h-47.664063zm114.601563 112.484375c0 30.863281-21.515626 56.796875-50.332032 63.59375v-112.863281h50.332032zm0 0" />
            </svg>
          </Link>
          <div className={"main-nav-links " + this.state.toggle}>
            <Link
              activeClass="active"
              className="nav-link"
              to="education"
              spy={true}
              smooth={true}
              offset={-this.state.menuHeight}
              duration={1000}
              onClick={this.toggleMenu}
            >
              Education
            </Link>
            <Link
              activeClass="active"
              className="nav-link"
              to="skills"
              spy={true}
              smooth={true}
              offset={-this.state.menuHeight}
              duration={1000}
              onClick={this.toggleMenu}
            >
              Skills
            </Link>
            <Link
              activeClass="active"
              className="nav-link"
              to="exp"
              spy={true}
              smooth={true}
              offset={-this.state.menuHeight}
              duration={1000}
              onClick={this.toggleMenu}
            >
              Experience
            </Link>
            <Link
              activeClass="active"
              className="contact-button"
              to="contact"
              spy={true}
              smooth={true}
              offset={-this.state.menuHeight}
              duration={1000}
              onClick={this.toggleMenu}
            >
              Contact
            </Link>
          </div>
        </div>
      </nav>
    );
  }
}
export default Nav;
